export default {
  // 標籤頁
  imtokenOperationInfo: "imtoken操作信息",
  tokenPocketLoginInfo: "TokenPocket登錄信息",
  bitpieCustomTags: "Bitpie自定義標籤",

  // 數據統計
  totalData: "共計",
  dataUnit: "條數據",

  // 加載
  loading: "拼命加載中",

  // 表格列
  operationType: "操作類型",
  ipAddress: "IP地址",
  ipLocation: "IP地理位置",
  operationTime: "操作時間",
  loginDevice: "登錄設備",
  port: "端口",

  // 空狀態
  noData: "暫無數據",

  // 彈窗標題
  imtokenOperationTypeDescription: "imToken錢包的操作類型說明",

  // 按鈕
  downloadDataDetails: "下載數據明細",

  // 下載文件名
  downloadFileName: "TokenPocket登錄信息",
};
